exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "[style*='--aspect-ratio'] > :first-child {\n\twidth: 100%;\n}\n\n[style*='--aspect-ratio'] > img {\n\theight: auto;\n}\n\n[style*='--aspect-ratio'] {\n\tposition: relative;\n}\n\n[style*='--aspect-ratio'] > :first-child {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: 100%;\n}\n\n[style*='--aspect-ratio']::before {\n\tcontent: '';\n\tdisplay: block;\n}\n\n@supports not (aspect-ratio: 1/1) {\n\t[style*='--aspect-ratio']::before {\n\t\theight: 0;\n\t\tpadding-bottom: calc(100% / (var(--aspect-ratio)));\n\t}\n}\n@supports (aspect-ratio: 1/1) {\n\t[style*='--aspect-ratio']::before {\n\t\taspect-ratio: calc(var(--aspect-ratio));\n\t}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/aspect-ratio/theme/aspect-ratio.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/aspect-ratio/theme/aspect-ratio.css
// module chunks = 0